import { array, boolean, mixed, number, object, string } from "yup";
const FieldWidgetDto = object({
  col_size: number().default(4),
  widget: string().optional(),
  type: string().optional()
});
const FieldOptionDto = object({
  id: string().required(),
  text: string().required(),
  value: string().required(),
  visible: boolean().default(true)
});
const IFieldDto = object({
  component_id: string().required(),
  helptext: string(),
  id: string().required(),
  label: string().required(),
  required: boolean(),
  ui: FieldWidgetDto,
  modelPath: string(),
  selectMultiple: boolean(),
  options: array(FieldOptionDto)
});
const IFieldGroupDto = object({
  type: string().default("field_group").required(),
  fields: array(IFieldDto),
  name: string()
});
const IScreenGroupScreensDto = object({ id: string() });
const IScreenDto = object({
  fields: array(IFieldGroupDto),
  id: string(),
  name: string(),
  type: string(),
  screens: array(IScreenGroupScreensDto),
  visible: boolean().default(true)
});
const ISchemaDto = object({
  screens: array(IScreenDto)
});
const InstructionConditionDto = object({
  op: string().required(),
  params: mixed(
    (input) => true
  )
});
const SchemaInstructionDto = object({
  action: array().optional(),
  condition: InstructionConditionDto,
  id: string().required(),
  type: string()
});
const SchemaRuleDto = object({
  id: string().required(),
  instructions: array(),
  isPreConfigured: boolean().default(true),
  modifiedOn: string().required(),
  name: string().required()
});
const SchemaAndRulesDto = object({
  schema: ISchemaDto,
  schemaRules: array(SchemaRuleDto)
});
export {
  FieldOptionDto,
  FieldWidgetDto,
  IFieldDto,
  IFieldGroupDto,
  ISchemaDto,
  IScreenDto,
  IScreenGroupScreensDto,
  InstructionConditionDto,
  SchemaAndRulesDto,
  SchemaInstructionDto,
  SchemaRuleDto
};
